import { machineTechniciansRouteStore } from '../domain/store';

import { listMachineTechnicians } from './index';

export default (number) => {
  machineTechniciansRouteStore.setValue('currentPage', number);
  return listMachineTechnicians();
};
